import { requestBase } from '@/plugins/axios'
// {phone,verificationCode}
export function messageModifyPhone(data) {
   return requestBase({
     url: 'v1/factory/worker/update/phone',
     method: 'POST',
     data: data
 })
}
// {phone}
export function sendVerificationCode(params) {
   return requestBase({
    url: 'v1/third-part/send/verification',
    method: 'GET',
    params: params
  })
}
// {phone,verificationCode,username,password}
export function messageModifyPassword(data) {
 return requestBase({
    url: 'v1/factory/worker/verification/change/password',
    method: 'POST',
    data: data
  })
}
// {newPassword,oldPassword}
export function modifyPassword(data) {
  return requestBase({
    url: 'v1/factory/admin/change/password',
    method: 'POST',
    params: data
  })
}
